import React, {FC} from 'react'
import {MDBContainer} from 'mdb-react-ui-kit'
import FadeIn from 'react-fade-in'


const AppContent:FC = ({children})  => {
  return (
    <div>
      <MDBContainer className={'text-center w-100 h-100 mt-5 mb-2'} fluid={true}>
        <FadeIn>
          <div className='card mb-10 h-100'>
            <div style={{backgroundColor : '#1F1E2C'}} className={'w-full flex justify-center items-center p-5 h-40'}>
              <h4 className={'text-white'}>              خرید  سهام بیمارستان مهر ایرامیان</h4>
            </div>
            <br />
            <br />
            <div className='card-body py-8 h-100'>
              {children}
            </div>
          </div>
        </FadeIn>
      </MDBContainer>
    </div>
  )
}

export {AppContent}
